import { MovementManager } from "../../../Managers/MovementManager";
import { IPiece, ISideEffect, MoveType, EffectType } from "../../../types";
import { BonusTurnHandler } from "./BonusTurnHandler";
import { EntangleHandler } from "./EntangleHandler";
import { PoisonHandler } from "./PoisonHandler";
import { RotateHandler } from "./RotateHandler";
import { ShadowEffectHandler } from "./ShadowHandler";
import { ZombificationHandler } from "./ZombificationHandler";

export type SideEffectHandlerParams = {
  inflictingPiece: IPiece; // the piece that caused the side effect
  sideEffects: ISideEffect[];
  currentTurnNumber: number;
  movementManager: MovementManager;
  moveInfo?: {
    moveType: MoveType;
    fromPosition: { row: number; col: number };
    toPosition: { row: number; col: number };
  };
};

export interface ISideEffectHandler {
  handleSideEffect(params: SideEffectHandlerParams): void;
}

export function GetSideEffectHandler(
  effectType: EffectType
): ISideEffectHandler {
  switch (effectType) {
    case EffectType.bonusTurn:
      return new BonusTurnHandler();
    case EffectType.entangle:
      return new EntangleHandler();
    case EffectType.poison:
      return new PoisonHandler();
    case EffectType.shadow:
      return new ShadowEffectHandler();
    case EffectType.zombify:
      return new ZombificationHandler();
    case EffectType.rotate:
      return new RotateHandler();
    case EffectType.capture:
    case EffectType.meadow:
    case EffectType.housemove:
    default:
      throw new Error(`No handler defined for ${effectType}`);
  }
}
